import React from 'react';
import PropTypes from 'prop-types';

import { Loader } from 'shared/components';
import requestsStatuses from 'modules/common/constants/requestsStatuses';

import theme from './PrivatePage.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  sessionRequestStatus: PropTypes.string,
  isSessionInitialized: PropTypes.bool.isRequired,
  firstAppointmentCheckCompleted: PropTypes.bool.isRequired,
};

const defaultProps = {
  sessionRequestStatus: requestsStatuses.default,
};

const PrivatePage = ({ children, isSessionInitialized, sessionRequestStatus, firstAppointmentCheckCompleted }) => {

  if (isSessionInitialized && sessionRequestStatus === requestsStatuses.success && firstAppointmentCheckCompleted) {
    return children;
  }

  return (
    <div className={ theme.root }>
      <Loader />
    </div>
  );
};

PrivatePage.propTypes = propTypes;
PrivatePage.defaultProps = defaultProps;

export default PrivatePage;
